import axios from '@/utils/axios_utils'
import applyCaseMiddleware from 'axios-case-converter'
import { API_PATH } from '@/constants'

const httpClient = (baseURL: string = API_PATH) => applyCaseMiddleware(axios.create({
  baseURL
}))

export const httpClientRoot = httpClient('/')
export default httpClient()
